module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loading":"Loading","app_down":"Application is not responding. Please refresh this application."},"fr":{"loading":"Chargement","app_down":"L\u0027application ne répond pas pour le moment, veuillez actualiser l\u0027application."}}')
  delete Component.options._Ctor
}
